
import { createElement } from "react";
import React from "react";
import { reactApi, reactElement } from "./fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Exception, createObj } from "./fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "./fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { TextValue, PageHeader } from "./Components/Text.js";
import { singleton, ofArray } from "./fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { useTranslation } from "react-i18next";
import { useAuth } from "react-oidc-context";
import { TextButton } from "./Components/Button.js";
import { RouterModule_nav } from "./fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { redirectUri } from "./AuthRedirect.js";
import Browser_Lock from "../public/assets/icons/Browser_Lock.svg";
import Browser_Warning from "../public/assets/icons/Browser_Warning.svg";
import { useEffectOnce } from "./fable_modules/Feliz.2.9.0/Internal.fs.js";
import { defaultOf } from "./fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import Browser_Error_404 from "../public/assets/icons/Browser_Error_404.svg";
import { captureException } from "./Sentry.js";

function ErrorFrame(props) {
    let elems_5, elems_4, elems_1, elems_2;
    return reactElement("div", createObj(ofArray([["className", join(" ", ["h-full", "flex", "justify-center", "content-center", "bg-background"])], (elems_5 = [reactElement("div", createObj(ofArray([["className", join(" ", ["grow", "max-w-lg", "my-auto", "p-6", "flex", "flex-col", "border", "border-border", "rounded-md", "bg-[#FFFFFF]"])], (elems_4 = [reactElement("div", {
        className: join(" ", ["mx-auto", "w-24", "h-24", "mb-4"]),
        children: reactApi.Children.toArray([props.Icon]),
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["mx-auto", "mb-5", "mt-8"])], (elems_1 = [createElement(PageHeader, {
        Text: props.ErrorTitle,
    })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["mx-auto", "mb-5"])], (elems_2 = [createElement(TextValue, {
        FontWeight: "normal",
        TestId: "",
        Text: props.ErrorText,
    })], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), reactElement("div", {
        className: join(" ", ["flex", "flex-col", "items-center", "gap-5"]),
        children: reactApi.Children.toArray(Array.from(props.Actions)),
    })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

export function ErrorContainer(props) {
    const t = useTranslation()[0];
    const auth = useAuth();
    return createElement(ErrorFrame, {
        Actions: ofArray([createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("error.to_dashboard"),
            OnClick: () => {
                RouterModule_nav(ofArray(["dashboard"]), 1, 1);
            },
            TestId: "error-to-dashboard-button",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("navbar.logout"),
            OnClick: () => {
                auth.removeUser();
                auth.signoutRedirect({
                    post_logout_redirect_uri: redirectUri(),
                });
            },
            TestId: "",
            Variant: "redButton",
        })]),
        ErrorText: props.ErrorText,
        ErrorTitle: props.ErrorTitle,
        Icon: props.Icon,
    });
}

export function SessionExpired() {
    let Icon, ErrorTitle, ErrorText;
    const t = useTranslation()[0];
    const auth = useAuth();
    return createElement(ErrorFrame, (Icon = Browser_Lock(), (ErrorTitle = t("error.session_expired_title"), (ErrorText = t("error.session_expired_description"), {
        Actions: singleton(createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("error.session_expired_login"),
            OnClick: () => {
                auth.signinRedirect();
            },
            TestId: "session-expired-login-button",
            Variant: "blueButton",
        })),
        ErrorText: ErrorText,
        ErrorTitle: ErrorTitle,
        Icon: Icon,
    }))));
}

export function BadRequest() {
    let Icon, ErrorTitle;
    const t = useTranslation()[0];
    return createElement(ErrorContainer, (Icon = Browser_Warning(), (ErrorTitle = t("error.unexpected_error_title"), {
        ErrorText: t("error.unexpected_error_description"),
        ErrorTitle: ErrorTitle,
        Icon: Icon,
    })));
}

export function Unauthorized() {
    const auth = useAuth();
    useEffectOnce(() => {
        if (auth.activeNavigator == null) {
            auth.signinRedirect();
        }
    });
    const matchValue = auth.error;
    if (matchValue == null) {
        return defaultOf();
    }
    else {
        return createElement(SessionExpired, null);
    }
}

export function Forbidden() {
    let Icon, ErrorTitle;
    const t = useTranslation()[0];
    return createElement(ErrorContainer, (Icon = Browser_Lock(), (ErrorTitle = t("error.forbidden_title"), {
        ErrorText: t("error.forbidden_description"),
        ErrorTitle: ErrorTitle,
        Icon: Icon,
    })));
}

export function NotFound() {
    let Icon, ErrorTitle;
    const t = useTranslation()[0];
    return createElement(ErrorContainer, (Icon = Browser_Error_404(), (ErrorTitle = t("error.not_found_title"), {
        ErrorText: t("error.not_found_description"),
        ErrorTitle: ErrorTitle,
        Icon: Icon,
    })));
}

export function InternalServerError() {
    let Icon, ErrorTitle;
    const t = useTranslation()[0];
    return createElement(ErrorContainer, (Icon = Browser_Warning(), (ErrorTitle = t("error.unexpected_error_title"), {
        ErrorText: t("error.unexpected_error_description"),
        ErrorTitle: ErrorTitle,
        Icon: Icon,
    })));
}

export function InvalidAuthError() {
    let Icon, ErrorTitle;
    const t = useTranslation()[0];
    useEffectOnce(() => {
        captureException(new Exception("Invalid auth error occured. - User is authenticated but token is invalid"));
    });
    return createElement(ErrorContainer, (Icon = Browser_Warning(), (ErrorTitle = t("error.unexpected_error_title"), {
        ErrorText: t("error.unexpected_error_description"),
        ErrorTitle: ErrorTitle,
        Icon: Icon,
    })));
}

